module.exports = __webpack_public_path__ + "img/atturo.a09deeb1.png";